export default __webpack_public_path__ + "static/media/empty-box.db55de1a.svg";